import api from 'app/javascript/src/utils/api'
import { camelizeKeys } from 'humps'
import { logErrorOnSentry } from '@/utils/errorReportingUtils.js'

interface BnplInfo {
  bnplMethods: string
  /** Itinerary flag from server that indicates whether BNPL is enabled for the itinerary */
  bnplEnabled: boolean
  currency: string
  userCountry: string
}

const useBnplInfo = async (
  itineraryId: string,
): Promise<
  Omit<BnplInfo, 'bnplEnabled'> & {
    /** Flag to determine whether BNPL should be enabled for payment on UI */
    isBnplEnabled: boolean
  }
> => {
  let data: BnplInfo
  try {
    const response = await api.get<any, { data: BnplInfo }>(`/api/products/${itineraryId}/allowed_payment_methods`)
    data = camelizeKeys(response.data)
  } catch (error) {
    logErrorOnSentry(error)
    return { userCountry: '', currency: '', bnplMethods: '', isBnplEnabled: false }
  }

  const { userCountry, currency, bnplEnabled, bnplMethods } = data

  return {
    userCountry,
    currency,
    bnplMethods,
    isBnplEnabled: bnplEnabled && userCountry === 'US' && currency === 'USD',
  }
}

export default useBnplInfo
